import React from 'react';
import useTranslation from '../../../../../../../hooks/translation/useTranslation';

const attributeClass = 'h-4 w-4  border-solid border-[2px] rounded-2xl';

function Statuses() {
  const { trans } = useTranslation();
  return (
    <div className="flex gap-7 lg:gap-5 justify-start lg:justify-center flex-wrap">
      <div className="flex gap-2">
        <div className={`${attributeClass} bg-gray-gr border-gray-semi-light-gr`} />
        <p className="m-0">
          {trans('chosen')}
        </p>
      </div>
      <div className="flex gap-2">
        <div className={`${attributeClass} bg-[#2BB673] border-[#006838]`} />
        <p className="m-0">
          {trans('available')}
        </p>
      </div>
      <div className="flex gap-2">
        <div className={`${attributeClass} bg-primary border-[#BE1E2D]`} />
        <p className="m-0">
          {trans('sold')}
        </p>
      </div>
      <div className="flex gap-2">
        <div className={`${attributeClass} bg-[#333] border-[#1a1a1a]`} />
        <p className="m-0">
          {trans('blocked')}
        </p>
      </div>
    </div>
  );
}

export default Statuses;
